import { bindedUpdateEmails } from 'modules/emails/actions';
import { reduxForm } from 'redux-form';
import EmailsForm from './form';

export default reduxForm({
  form: 'emails',
  onSubmit: bindedUpdateEmails,
  enableReinitialize: true,
})(EmailsForm);
